// import {getTreeDelta, applyTreeDelta} from './treeOps'
// import {getSourceDelta, applySourceDelta} from './sourceOps'
// import {getSchemaDelta, applySchemaDelta} from './schemaOps'
import jiff from 'jiff'
import {compare} from 'fast-json-patch'
import {
  expandTree,
  expandSchema,
  expandSource,
  compressTree,
  compressSchema,
  compressSource,
  hydrateTree,
  hydrateSchema,
  hydrateSource,
} from '../scripts/translation'
import {traverseSchema} from '../scripts/utils'

if (typeof window !== 'undefined') {
  window._ms_jiff = jiff
}

let transformValue = (value) => {
  if (typeof value === 'undefined' || value === null) {
    return []
  } else if (Array.isArray(value)) {
    return value
  } else if (value._name) {
    return [value]
  } else {
    return [{_name: value}]
  }
}

export class ControlManagerContent {
  constructor(data) {
    this.construct(data)
  }

  construct(data = {}) {
    // console.log('content construct with', data)
    let {tree, source, schema} = data
    tree = tree || {}
    this.tree = tree
    this.source = source
    this.schema = schema
    this.expand()
    return this
  }

  hydrate(includes = {}) {
    this.tree = hydrateTree(this.tree, includes)
    // console.log('tree OK')

    this.source = hydrateSource(this.source, includes)
    // console.log('source OK')
    this.schema = hydrateSchema(this.schema, includes)
    // console.log('schema OK')
    return this
  }

  setTemplates(tpl) {
    this.source = this.source || {}
    this.source._templates = tpl
  }

  setValue(name, value) {
    let {tree} = this
    if (!tree[name]) {
      tree[name] = {}
    }
    tree[name].content = tree[name].content || []
    tree[name].content = transformValue(value)
  }

  getValue(name) {
    let {tree} = this
    if (!tree[name]) {
      return null
    }
    if (tree[name].content && tree[name].content.length) {
      return tree[name].content
    }
    return null
  }

  setSource(location, value) {
    let locationArr = location.split('.')
    let {source} = this
    let target = source
    while (locationArr.length > 1) {
      let nextLevel = locationArr.shift()
      target = target[nextLevel]
    }
    let finalLevel = locationArr.shift()
    target[finalLevel] = transformValue(value)
  }

  getSource(location) {
    let locationArr = location.split('.')
    let {source} = this
    let target = source
    while (locationArr.length) {
      let nextLevel = locationArr.shift()
      target = target[nextLevel]
    }
    return target
  }

  setTree(value) {
    this.tree = value
  }

  getTree(compressed) {
    if (compressed) {
      return compressTree(this.tree)[0]
    } else {
      return this.tree
    }
  }

  expand() {
    this.source = expandSource(this.source)
    this.schema = expandSchema(this.schema)
    this.tree = expandTree(this.tree)
    return this
  }

  validateTree(source = this.source, schema = this.schema) {
    // throw away items that don't belong inside the tree
    // console.log('validating tree', source, schema, this.tree)
    traverseSchema(schema, source, this.tree, (ctrl, curSrc) => {
      // console.log('perusing control', ctrl)
      // console.log('with state', this.tree[ctrl.name])
      // console.log('and source', curSrc)
      curSrc = curSrc || []
      const leaf = this.tree[ctrl.name]
      if (leaf && leaf.content && leaf.content.length && ctrl.source) {
        const name = leaf.content[0]._name
        // console.log('FIND %s in', name, curSrc)
        const idx = curSrc.findIndex((elm) => {
          return elm._name === name
        })
        if (idx === -1 && !['user', 'parentId'].includes(ctrl.name)) {
          // console.log('DELETING ELEMENT', ctrl.name, leaf.content[0])
          this.tree[ctrl.name].content = []
        }
      }
    })
  }

  serialize() {
    // console.log('serializing', this.source, this.tree, this.schema)
    const {tree, source, schema} = this
    let includes = []
    const res = {}
    if (tree) {
      const [comptree, treeIncludes] = compressTree(this.tree, true)
      includes = [...includes, ...treeIncludes]
      res.tree = comptree
    }
    if (source) {
      const [compsource, sourceIncludes] = compressSource(this.source)
      includes = [...includes, ...sourceIncludes]
      res.source = compsource
    }
    if (schema) {
      const [compschema, schemaIncludes] = compressSchema(this.schema)
      includes = [...includes, ...schemaIncludes]
      res.schema = compschema
    }
    if (includes.length) res.includes = [...new Set([...includes])]
    // console.log(res)
    return res
  }

  static _getRefData(ref) {
    // console.log('grabbing stuff from ref', ref)
    const tree = ref.getTree()
    const source = ref.getSource(false)
    const schema = ref.getSchema(false)
    const res = {}
    if (tree) {
      res.tree = expandTree(tree)
    }
    if (source) {
      res.source = expandSource(source)
    }
    if (schema) {
      res.schema = expandSchema(schema)
    }
    return res
  }

  constructFromRef(ref) {
    const res = ControlManagerContent._getRefData(ref)
    return this.construct(res)
  }

  getData(compressed) {
    const {tree, source, schema} = this
    const res = {}
    // console.log('pre-get data schema', JSON.parse(JSON.stringify(schema)))
    // console.log('getting data (compressed: %s)', compressed)
    if (compressed) {
      let allIncludes = []
      if (tree) {
        const [compTree, compTreeIncludes] = compressTree(tree)
        // console.log('got %s and includes:', 'tree', compTreeIncludes, compTree)
        res.tree = compTree
        allIncludes = [...allIncludes, ...compTreeIncludes]
      }
      if (source) {
        const [compSource, compSourceIncludes] = compressSource(source)
        // console.log('got %s and includes:', 'source', compSourceIncludes, compSource)
        res.source = compSource
        allIncludes = [...allIncludes, ...compSourceIncludes]
      }
      if (schema) {
        const [compSchema, compSchemaIncludes] = compressSchema(schema)
        // console.log('got %s and includes:', 'schema', compSchemaIncludes, compSchema)
        res.schema = compSchema
        allIncludes = [...allIncludes, ...compSchemaIncludes]
      }
      if (allIncludes.length) res.includes = [...new Set([...allIncludes])]
    } else {
      if (tree) res.tree = expandTree(tree)
      if (source) res.source = expandSource(source)
      if (schema) res.schema = expandSchema(schema)
    }
    // console.log('post-get data schema', JSON.parse(JSON.stringify(schema)))
    // console.log('returning data', res, compressed)
    return res
  }

  getRefDelta(ref) {
    const data = ControlManagerContent._getRefData(ref)
    // console.log('got ref data', data)
    return this.getDelta(data)
  }

  getDelta(data, oldDataRaw = this) {
    // const {
    //   tree: oldTree,
    //   source: oldSource,
    //   schema: oldSchema
    // } = oldData
    const {tree, source, schema} = data
    const oldData = new ControlManagerContent({
      tree: oldDataRaw.tree,
      source: oldDataRaw.source,
      schema: oldDataRaw.schema,
    })
    const newData = new ControlManagerContent({tree, source, schema})
    // console.log('============THEIR DATA==============')
    // console.log(JSON.stringify(newData.serialize(), null, 2))
    // console.log('====================================')
    // console.log('=============OUR DATA===============')
    // console.log(JSON.stringify(oldData.serialize(), null, 2))
    // console.log('====================================')
    // console.log('==============DELTA=================')
    // return jiff.diff(oldData, newData)
    // console.log('trying to compare')
    // console.log(oldData)
    // console.log('-----------------------------')
    // console.log(newData)
    const comp = compare(oldData.serialize(), newData.serialize(), true)
    // console.log(JSON.stringify(comp, null, 2))
    // console.log('====================================')
    // console.log('====================================')
    return comp
    // const dTree = getTreeDelta(oldTree, tree)
    // const dSource = getSourceDelta(oldSource, source)
    // const dSchema = getSchemaDelta(oldSchema, schema)
    // // console.log('got source delta', dSource)
    // const res = {}
    // if( dTree ) res.tree = dTree
    // if( dSource ) res.source = dSource
    // if( dSchema ) res.schema = dSchema
    // return res
  }

  updateRef(oldRef, newRef) {
    const {source, schema, tree} = this
    const pack = {source, schema, tree}
    const str = JSON.stringify(pack)
    const re = new RegExp(oldRef, 'g')
    const newStr = str.replace(re, newRef)
    const newPack = JSON.parse(newStr)
    this.tree = newPack.tree
    this.source = newPack.source
    this.schema = newPack.schema
    return this
  }

  setDelta(delta) {
    // const {tree, source, schema} = delta
    // if( tree ) this.tree = applyTreeDelta(this.tree, tree)
    // if( source ) this.source = applySourceDelta(this.source, source)
    // if( schema ) this.schema = applySchemaDelta(this.schema, schema)
    // return this
    const ownData = new ControlManagerContent({
      tree: this.tree,
      source: this.source,
      schema: this.schema,
    })
    // console.log('about to set this delta', ownData.serialize())
    // console.log(JSON.stringify(delta, null, 2))
    const patched = jiff.patch(delta, ownData.serialize())
    this.tree = patched.tree
    this.source = patched.source
    this.schema = patched.schema
    return this
  }
}

if (typeof window !== 'undefined') {
  window._ms_ConContent = ControlManagerContent
}
